interface EmptyPumpStateProps {
  hasSearchQuery: boolean;
}

export default function EmptyPumpState({ hasSearchQuery }: EmptyPumpStateProps) {
  return (
    <div className="text-center py-8 text-gray-500">
      {hasSearchQuery ? "Nenhuma bomba encontrada" : "Nenhuma bomba cadastrada"}
    </div>
  );
}
